export default "__VITE_ASSET__m1eYH3nw__"